import { Component, computed, inject, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CookiesFacade } from 'src/app/_core/state/dialogs/cookies/cookies.facade';
import { CookieStep } from 'src/app/_core/state/dialogs/cookies/service/models/cookie-step.model';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'opac-cookies-dialog',
  templateUrl: './cookies-dialog.component.html',
  styleUrls: ['./cookies-dialog.component.scss']
})
export class CookiesDialogComponent {
  @ViewChild(DialogComponent, { static: true }) dialogComponent!: DialogComponent;

  private readonly cookiesFacade = inject(CookiesFacade);

  readonly isOpen = toSignal(this.cookiesFacade.isOpen$);
  readonly step = toSignal(this.cookiesFacade.step$);
  readonly hasConsent = toSignal(this.cookiesFacade.hasConsent$);

  readonly title = computed(() => {
    if (this.step() === 'settings') {
      return 'cookies.title.settings';
    } else {
      return 'cookies.title.text';
    }
  });

  changeStep(step: CookieStep, event: Event) {
    // We need to avoid the default behavior because when the step changes, Angular re-renders the component,
    // and the event propagation causes the dialog box to close automatically.
    event.preventDefault();
    event.stopPropagation();

    this.cookiesFacade.changeStep(step);
    this.dialogComponent.focus();
  }

  acceptAllCookies() {
    this.cookiesFacade.acceptAllCookies();
  }

  rejectCookies() {
    this.cookiesFacade.rejectCookies();
  }

  confirmPreferences() {
    this.cookiesFacade.confirmPreferences();
  }

  closeDialog() {
    this.cookiesFacade.closeCookiesDialog();
  }
}
